// extracted by mini-css-extract-plugin
module.exports = {"IconButton":"Menu_IconButton__3zYLp"};